import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { KeyboardService } from 'src/app/services/keyboard/keyboard.service';

@Component({
    selector: 'app-leave-confirm-dialog',
    templateUrl: './leave-confirm-dialog.component.html',
    styleUrls: ['./leave-confirm-dialog.component.css'],
    standalone: false
})
export class LeaveConfirmDialogComponent {
  private readonly destroyRef = inject(DestroyRef);
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { message: string },
      private keyboardService: KeyboardService,
    private dialogRef: MatDialogRef<LeaveConfirmDialogComponent>,
    matDialog: MatDialog
  ) {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
   ngOnInit(): void {

    this.keyboardService.onKey('Escape', () => {
   this.dialogRef.close(false);
  }, this.destroyRef);
  }
}

